import * as Interfaces from '../interfaces/dropdown';

export class Dropdown implements Interfaces.Dropdown {
    public constructor(id: any, friendlyName: string) {
        this.id = id;
        this.friendlyName = friendlyName;
    }

    public id: any;
    public friendlyName: string;
}
